import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm_comuni',
  templateUrl: './crm_comuni.component.html',
  styleUrls: ['./crm_comuni.component.css']
})
export class CrmComuniComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }

}
